<div class="flex gap-4 justify-center border border-green-300 rounded-md p-4 bg-green-50 mx-4">
  <select class="text-box w-auto" [(ngModel)]="selectedMonth" (change)="updatedDate()">
    @for (m of months; track m) {
      <option [ngValue]="m">{{m.Description}}</option>
    }
  </select>
  <select class="text-box w-auto" [(ngModel)]="selectedYear" (change)="updatedDate()">
    @for (y of years; track y) {
      <option [ngValue]="y">{{y}}</option>
    }
  </select>
</div>

<div class="lg:flex hidden lg:visible">
  <div>
    <div class="m-4 mb-1 flex">
      <p class="w-16 text-center text-sm font-bold">Sun</p>
      <p class="w-16 text-center text-sm font-bold">Mon</p>
      <p class="w-16 text-center text-sm font-bold">Tue</p>
      <p class="w-16 text-center text-sm font-bold">Wed</p>
      <p class="w-16 text-center text-sm font-bold">Thu</p>
      <p class="w-16 text-center text-sm font-bold">Fri</p>
      <p class="w-16 text-center text-sm font-bold">Sat</p>
    </div>
    <div class="p-4 pt-0">
      @for (w of weeksInMonth; track w; let i = $index) {
        <div class="flex">
          @for (d of daysInWeek; track d; let i2 = $index) {
            <div class="">
              <app-calendar-cell [date]="datesForCells[(i*7)+i2]" [events]="eventsForCells[(i*7)+i2]" [focusMonth]="selectedMonth.ID" (selectedDate)="selectedChanged($event)"></app-calendar-cell>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <div class="m-4 mt-8 w-1/2">
    <app-day-detail [events]="this.selectedEvents" [selectedDate]="this.selectedDate" (DeleteEvent)="deleteEvent($event)"></app-day-detail>
  </div>
</div>

<div class="lg:hidden mt-4">
  @for (e of this.allEvents; track e) {
    <div>
      <app-scheduled-audit [event]="e" (DeleteEvent)="deleteEvent2($event)" [showDate]="true"></app-scheduled-audit>
    </div>
  }
</div>
